'use strict';

import { CoreRepository } from '../CoreRepository';
import { UserAppWebhook } from '../../Entities/User/UserAppWebhook';
import { UserAppWebhookCollection } from '../../Collections/User/UserAppWebhookCollection';

export class UserAppWebhookRepository extends CoreRepository {
  public getUserAppWebhooks(reference: string, options: object = {}, criteria: object = null) {
    if (!options) {
      options = {};
    }

    if (criteria) {
      options['criteria'] = criteria;
    }

    return this.webAPI.getUserAppWebhooks(reference, options).then((response) => {
      const collection = new UserAppWebhookCollection();

      response.data.forEach((collectionItemData) => {
        const collectionItem = new UserAppWebhook();
        collectionItem.hydrate(collectionItemData);

        collection.addItem(collectionItem);
      });

      collection.setOffset(response.offset);
      collection.setLimit(response.limit);
      collection.setTotal(response.total);

      return collection;
    });
  }

  /*
    public getUserAppWebhook(userId: number, options: object = null){
        if( !options )
        {
        options = {};
        }

        return this.webAPI.getUserAppWebhook(userId, options)
        .then( response => {
            if( !response )
            {
            return false;
            }

            let userAppWebhook = new UserAppWebhook();
            userAppWebhook.hydrate(response);

            return userAppWebhook;
        });
    }
    */

  public createUserAppWebhook(reference: string, payload: object = {}) {
    return this.webAPI.createUserAppWebhook(reference, payload).then((response) => {
      const userAppWebhook = new UserAppWebhook();
      userAppWebhook.hydrate(response);

      return userAppWebhook;
    });
  }

  public updateUserAppWebhook(appWebhookId: number, payload: object = {}) {
    return this.webAPI.updateUserAppWebhook(appWebhookId, payload).then((response) => {
      const userAppWebhook = new UserAppWebhook();
      userAppWebhook.hydrate(response);

      return userAppWebhook;
    });
  }

  public deleteUserAppWebhook(appWebhookId: number) {
    return this.webAPI.deleteUserAppWebhook(appWebhookId).then((response) => {
      return response;
    });
  }
}
